module.exports = __webpack_public_path__ + "img/mesa_l001d.f2754f1f.png";